import { App } from '@/apps'
import asyncThunk from '@/lib/asyncThunk'
import { AdminRole } from '@/out/admin'
import { Branding } from '@/out/branding'

type Request = Record<never, never>

export type AppStatus = 'inactive' | 'free-trial' | 'subscription' | 'enterprise' | 'cancelled'

type FreeTrial = {
  status: 'free-trial'
  credits: number
  freeTier: number
}

type ActiveSubscription = {
  status: 'subscription'
  credits: number
}

export type AppConfig<T extends AppStatus = AppStatus> = FreeTrial | ActiveSubscription | { status: T }

export type Response = {
  id: string
  firstName: string | null
  lastName: string | null
  email: string
  role: AdminRole
  billing: Record<App, AppConfig>
  branding: Branding
  account: {
    id: string
    name: string
    hasOnboarded: boolean
  }
}

export const bootstrapAdmin = asyncThunk<Request, Response>({
  name: 'admins/bootstrap',
  uri: '/admins/bootstrap',
})
